var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "box view-nav-bar" }, [
        _c("div", { staticClass: "d-flex align-items-center w-100" }, [
          _c(
            "div",
            { staticClass: "flex-grow-1" },
            [
              _c(
                "router-link",
                {
                  staticClass: "mr-3",
                  attrs: { to: "/admissions/cinema/" + _vm.theatreCode },
                },
                [
                  _c("icon", { attrs: { name: "chevron-left" } }),
                  _vm._v(" Back\n                "),
                ],
                1
              ),
              _vm._v(" "),
              _c("strong", [_vm._v(_vm._s(_vm.theatreCode))]),
              _vm._v(" "),
              _vm.bucket.theatre_name
                ? _c("span", { staticClass: "ml-2" }, [
                    _vm._v(_vm._s(_vm.bucket.theatre_name)),
                    _vm.bucket.city
                      ? _c("span", [_vm._v(", " + _vm._s(_vm.bucket.city))])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("span", { staticClass: "text-muted ml-2" }, [
                _vm._v("— cinema year "),
                _c("strong", [_vm._v(_vm._s(_vm.year))]),
                _vm._v(", all sessions vs. Brightfish preshow"),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.loading
        ? _c("div", { staticClass: "box" }, [
            _c(
              "div",
              { staticClass: "box-content text-center text-muted py-4" },
              [_vm._v("Loading…")]
            ),
          ])
        : !_vm.totals.weeks
        ? _c("div", { staticClass: "box" }, [
            _c(
              "div",
              { staticClass: "box-content text-center text-muted py-4" },
              [
                _vm._v(
                  "No reported admissions for " +
                    _vm._s(_vm.theatreCode) +
                    " in " +
                    _vm._s(_vm.year) +
                    "."
                ),
              ]
            ),
          ])
        : [
            _c("div", { staticClass: "box" }, [
              _c("div", { staticClass: "box-content" }, [
                _c("table", { staticClass: "shx-table w-100 mt-2" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("tbody", [
                    _c("tr", [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _vm._v(_vm._s(_vm.formatInt(_vm.totals.admissions))),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _vm._v(_vm._s(_vm.formatInt(_vm.totals.avg_week))),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [_vm._v("100%")]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.totals.real_weighted != null
                                ? _vm.totals.real_weighted + "%"
                                : "—"
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.totals.real_weighted != null &&
                        _vm.totals.real_weighted <= 90
                          ? _c(
                              "span",
                              {
                                staticClass: "badge badge-warning ml-1",
                                attrs: {
                                  title:
                                    "Minimum real: " +
                                    _vm.totals.real_min +
                                    "%",
                                },
                              },
                              [_vm._v("⚠")]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _vm._v(
                          _vm._s(_vm.formatInt(_vm.totals.admissions_preshow))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _vm._v(
                          _vm._s(_vm.formatInt(_vm.totals.avg_week_preshow))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm.totals.pct_preshow !== null
                              ? _vm.totals.pct_preshow + "%"
                              : "—"
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-muted small mt-2 mb-0" }, [
                  _vm._v("\n                    Averages over "),
                  _c("strong", [_vm._v(_vm._s(_vm.totals.weeks))]),
                  _vm._v(" week"),
                  _vm.totals.weeks !== 1 ? _c("span", [_vm._v("s")]) : _vm._e(),
                  _vm._v("\n                    of "),
                  _c("code", [_vm._v("admissions_week")]),
                  _vm._v(
                    ", compiled and estimated alike. Preshow = rows with\n                    "
                  ),
                  _c("code", [_vm._v("saleshouse = BF")]),
                  _vm._v(
                    "; all sessions = no filter on sales house or Movix id.\n                    "
                  ),
                  _c("strong", [_vm._v("Real %")]),
                  _vm._v(" is the admissions-weighted average of "),
                  _c("code", [_vm._v("real")]),
                  _vm._v(
                    ":\n                    97.5 = fully compiled from Cinedata, lower = partly estimated.\n                "
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "box" }, [
              _c(
                "div",
                { staticClass: "box-content" },
                [
                  _c("heading", {
                    attrs: {
                      upper: "Top movies",
                      lower:
                        "Top " +
                        _vm.movies.length +
                        " by admissions in " +
                        _vm.year +
                        ", all sales houses",
                      border: "",
                    },
                  }),
                  _vm._v(" "),
                  _c("table", { staticClass: "shx-table w-100 mt-2" }, [
                    _vm._m(3),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.movies, function (movie, index) {
                        return _c("tr", { key: movie.movix_id }, [
                          _c("td", { staticClass: "text-muted" }, [
                            _vm._v(_vm._s(index + 1)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _c(
                                "router-link",
                                { attrs: { to: "/history/" + movie.movix_id } },
                                [_vm._v(_vm._s(movie.movix_id))]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(movie.title || "—"))]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(_vm._s(movie.weeks)),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(_vm._s(_vm.formatInt(movie.admissions))),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(
                              _vm._s(movie.pct !== null ? movie.pct + "%" : "—")
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(
                              _vm._s(_vm.formatInt(movie.admissions_preshow))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(
                              _vm._s(
                                movie.pct_preshow !== null
                                  ? movie.pct_preshow + "%"
                                  : "—"
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  movie.real_weighted != null
                                    ? movie.real_weighted + "%"
                                    : "—"
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            movie.real_weighted != null &&
                            movie.real_weighted <= 90
                              ? _c(
                                  "span",
                                  { staticClass: "badge badge-warning ml-1" },
                                  [_vm._v("⚠")]
                                )
                              : _vm._e(),
                          ]),
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("tfoot", [
                      _c("tr", [
                        _c("td", { attrs: { colspan: "4" } }, [
                          _c("strong", [
                            _vm._v("Top " + _vm._s(_vm.movies.length)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-right" }, [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.formatInt(_vm.topAdmissions))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-right" }, [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.pct(
                                  _vm.topAdmissions,
                                  _vm.totals.admissions
                                )
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-right" }, [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.formatInt(_vm.topPreshow))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-right" }, [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.pct(
                                  _vm.topPreshow,
                                  _vm.totals.admissions_preshow
                                )
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td"),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", { staticClass: "text-right" }, [_vm._v("Admissions")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-120" }, [
          _vm._v("Avg / week"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-120" }, [
          _vm._v("% of all"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [_vm._v("Real %")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [
      _c("strong", [_vm._v("All sessions")]),
      _vm._v(" "),
      _c("span", { staticClass: "text-muted small ml-2" }, [
        _vm._v("every title, every sales house"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [
      _c("strong", [_vm._v("Preshow sessions")]),
      _vm._v(" "),
      _c("span", { staticClass: "text-muted small ml-2" }, [
        _vm._v("sales house BF"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "shx-th-50" }, [_vm._v("#")]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-80" }, [_vm._v("Movix")]),
        _vm._v(" "),
        _c("th", [_vm._v("Title")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [_vm._v("# Weeks")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right" }, [_vm._v("Admissions")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [
          _vm._v("% of all"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-120" }, [
          _vm._v("Preshow (BF)"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-120" }, [
          _vm._v("% of preshow"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [_vm._v("Real %")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }